exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2ffe5ebf] .el-menu--horizontal {\n  border-radius: 6px;\n}\n[data-v-2ffe5ebf] .el-menu--horizontal .el-submenu .el-submenu__title {\n    height: 36px;\n    line-height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n[data-v-2ffe5ebf] .el-menu--horizontal i {\n    color: #fff;\n}\n", ""]);

// exports
